import Super from 'client-portal/routes/-request';
import classic from 'ember-classic-decorator';

@classic
export default class Widget extends Super {}
